// extracted by mini-css-extract-plugin
module.exports = {"container":"PendingPostsBanner_container__Uj2_a","content":"PendingPostsBanner_content__D7fWF","icon":"PendingPostsBanner_icon__mxvos"};